var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"placement":"top","content":_vm.blockReason}},[_c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click', _vm.project)}}},[_vm._v(" "+_vm._s(_vm.labels.unblock)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }